import { Link, NavLink } from 'react-router-dom'

import { cx } from '@/lib/browser/class-names'

import { useAuth } from '@/lib/auth/auth-context'
import { canOpenPage, type GatedPage } from '@/lib/auth/roles'

import { AccountMenu } from './AccountMenu'

const NAV_TABS: readonly { tab: GatedPage; to: string; label: string; end?: boolean }[] = [
  { tab: 'portfolio', to: '/', label: 'Portfolio', end: true },
  { tab: 'company', to: '/company', label: 'Company' },
  { tab: 'admin', to: '/admin', label: 'Admin' },
  { tab: 'files', to: '/files', label: 'Files' },
]

export function AppHeader() {
  const { session } = useAuth()

  const role = session?.role ?? null

  const navClass = ({ isActive }: { isActive: boolean }) =>
    cx('canopy-nav-item', isActive && 'active')

  return (
    <header className="canopy-topbar">
      <Link to="/" className="canopy-logo" aria-label="Serent Canopy home">
        <span className="canopy-logo-img-fallback">
          <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path
              d="M8 1.5C5.5 1.5 3.5 3.8 3.5 6.5c0 1.6.7 3 1.8 3.9L4.8 13h6.4l-.5-2.6c1.1-.9 1.8-2.3 1.8-3.9 0-2.7-2-5-4.5-5z"
              fill="white"
              opacity=".95"
            />
            <path d="M6.2 13v1.2a1.3 1.3 0 002.6 0V13" fill="white" opacity=".7" />
          </svg>
        </span>
        <span className="canopy-logo-text">
          Serent <span>Canopy</span>
        </span>
      </Link>

      <nav className="canopy-nav">
        {NAV_TABS.filter(({ tab }) => canOpenPage(role, tab)).map(({ tab, to, label, end }) => (
          <NavLink key={tab} to={to} end={end ?? false} className={navClass}>
            {label}
          </NavLink>
        ))}
      </nav>

      <div className="canopy-topbar-right">
        {canOpenPage(role, 'askAi') && (
          <NavLink to="/ask-ai" className="canopy-ask-ai-btn">
            <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path
                d="M8 1a7 7 0 100 14A7 7 0 008 1zm0 3a1 1 0 110 2 1 1 0 010-2zm1 8H7V7h2v5z"
                fill="currentColor"
              />
            </svg>
            Ask AI
          </NavLink>
        )}
        <AccountMenu />
      </div>
    </header>
  )
}
